import { Controller, useForm } from "react-hook-form";
import { Dialog } from "components/Dialog";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";

import { netCall } from "utils/netCall";
import { UserManagementApiUrl } from "environment/routeSettings";
import { toast } from "react-toastify";
import { Icon } from "components/Icon";
import { TResponseCode } from "utils/netCall/types";

type TProps = {
  userId?: string;
  isOpen?: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export type TAddFormTypes = {
  password: string;
};

export function ResetPasswordModal(props: TProps) {
  const { isOpen = false, onClose, userId, onSuccess } = props;

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<TAddFormTypes>({
    defaultValues: undefined,
  });

  const onSubmitClick = async (data: TAddFormTypes) => {
    setIsLoading(true);
    const res = await netCall<any>({
      method: "POST",
      endPoint: `${UserManagementApiUrl()}/api/SamaUser/ResetPassword`,
      body: {
        userId: userId,
        newPassword: data.password,
        temporary: true,
      },
    });
    if (res.responseCode === TResponseCode.OK) {
      setIsLoading(false);
      toast.success(t("operationSuccessful"));
      onSuccess();
    } else {
      setIsLoading(false);
      toast.error(t("operationFailed"));
    }
  };

  return (
    <Dialog
      maxWidth={false}
      dialogTitle={t("resetPassword")}
      open={isOpen}
      onClose={onClose}
      canClose={!isLoading}
    >
      <form className="p-4 w-[480px]" onSubmit={handleSubmit(onSubmitClick)}>
        <div>
          <span>{t("chooseNewPassword")}</span>
        </div>
        <div className="flex w-full mt-4">
          <Controller
            name={"password"}
            control={control}
            rules={{
              required: true,
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("password")}
                  placeholder={t("password")}
                  type={showPassword ? "text" : "password"}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-2/3"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setShowPassword((prev) => !prev);
                          }}
                          onMouseDown={(e) => e.preventDefault()}
                          edge="end"
                        >
                          {!showPassword ? (
                            <Icon
                              className={"text-gray-90"}
                              icon={"MdVisibilityOff"}
                              fontSize={"18px"}
                            />
                          ) : (
                            <Icon
                              icon={"MdVisibility"}
                              className={"text-gray-90"}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              );
            }}
          />
        </div>
        <div className="col-span-12 flex items-center justify-end mt-3">
          <Button
            className="w-20"
            loading={isLoading}
            type="submit"
            variant="contained"
          >
            {t("reset")}
          </Button>
        </div>
      </form>
    </Dialog>
  );
}
